import { render } from "./LaravelPagination.vue?vue&type=template&id=36eed53c&scoped=true&ts=true"
import script from "./LaravelPagination.vue?vue&type=script&lang=ts"
export * from "./LaravelPagination.vue?vue&type=script&lang=ts"

import "./LaravelPagination.vue?vue&type=style&index=0&id=36eed53c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eed53c"]])

export default __exports__